module.exports = __webpack_public_path__ + "media/images/front/materiales_inf_m-fa98402dedc56ea2c5c594dcf722ad55.jpg";